<template>
    <div class="nasabah">
        <p class="title">Nasabah Deposit</p>
        <div class="content">
            <b-tabs content-class="mt-3" lazy>
                <b-tab title="Baru" @click="changeStatus('request')"></b-tab>
                <b-tab title="Diterima" @click="changeStatus('accepted')"></b-tab>
                <b-tab title="Ditolak" @click="changeStatus('rejected')"></b-tab>
            </b-tabs>
            <table class="table table-striped table-bordered">
                <thead class="text-center">
                    <tr>
                        <th>No</th>
                        <th>Nama</th>
                        <th>
                            Platform
                            <div class="form-group mb-0">
                                <select name="" id="" v-model="platform" @change="filterPlatform">
                                    <option value="">All</option>
                                    <option v-for="(data, i) in dataPlatform" :key="i" :value="data.code">{{ data.name }}</option>
                                </select>
                            </div>
                        </th>
                        <th>Bank</th>
                        <th>No Rekening</th>
                        <th>Jumlah</th>
                        <th>Tanggal Deposit</th>
                        <th>Setatus</th>
                        <th>Aksi</th>
                    </tr>
                </thead>
                <tbody>
                    <td colspan="9" v-show="loadingData" style="text-align: center">
                        <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </td>
                    <tr v-for="(data, i) in dataNsb" :key="i" v-show="loadingData == false && dataNsb.length != 0">
                        <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                        <td>{{ data.account_name }}</td>
                        <td>
                            {{ data.platform.name }}
                        </td>
                        <td>
                            {{ data.bank_name }}
                        </td>
                        <td>
                            {{ data.account_no }}
                        </td>
                        <td>{{ currencyFormat(data.amount) }}</td>
                        <td>
                            <span v-if="data.deposit_date">{{ data.deposit_date | formatDate }}</span>
                        </td>
                        <td>{{ data.status }}</td>
                        <td>
                            <button type="button" class="buttons btn-info btn-xs" @click="openDetail(data, 'detail')">
                                Detail
                            </button>
                            <div v-if="statusNasabah == 'request'">
                                <button type="button" class="buttons btn-success btn-xs" @click="openDetail(data, 'new')">
                                    Terima
                                </button>
                                <button type="button" class="buttons btn-danger btn-xs" @click="openDetail(data, 'old')">
                                    Tolak
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-show="loadingData == false && dataNsb.length == 0">
                        <td class="text-center" colspan="9">No Data</td>
                    </tr>
                </tbody>
            </table>
            <b-pagination
                v-model="currentPage"
                :total-rows="dataNsb.length"
                :per-page="perPage"
                aria-controls="new-table"
                v-show="dataNsb.length > 10"
            ></b-pagination>
        </div>
        <!-- <template id="detail"> -->
        <div class="wrap-detail" :class="{ activeDetail: showDetail }">
            <div class="header-title">
                <h5 class="title-detail">Detail Deposit</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showDetail = false">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div v-if="showDetail">
                <div>
                    <label class="label">Nama</label> <span> : </span> <span>{{ detailDeposit.account_name }}</span>
                </div>
                <div>
                    <label class="label">Platform</label> <span> : </span> <span>{{ detailDeposit.platform.name }}</span>
                </div>
                <div>
                    <label class="label">Bank</label> <span> : </span> <span>{{ detailDeposit.bank_name }}</span>
                </div>
                <div>
                    <label class="label">No Rekening</label> <span> : </span> <span>{{ detailDeposit.account_no }}</span>
                </div>
                <div>
                    <label class="label">Jumlah</label> <span> : </span> <span>{{ detailDeposit.amount }}</span>
                </div>
                <div>
                    <label class="label">Tanggal Deposit</label> <span> : </span> <span>{{ detailDeposit.deposit_date | formatDate }}</span>
                </div>
                <div>
                    <label class="d-block label">Bukti Transfer</label>
                    <img :src="imgResult" alt="Bukti Transfer" class="image" />
                </div>
            </div>
        </div>
        <!-- </template> -->
        <b-modal ref="modalAccepted" title="Konfirmasi Deposit">
            <div class="d-block">
                <h5>Terima Deposit {{ detailDeposit.account_name }} ?</h5>
                <div class="form-group d-flex">
                    <label for="" class="label">Kurs hari ini</label>
                    <div>
                        <input type="text" placeholder="masukkan kurs hari ini" class="form-input" v-model="rule_usd" @input="checngeResult" /> <br />
                        <small>Jumlah Deposit USD : {{ resultUsd }}</small>
                        <div v-if="$v.rule_usd.$error">
                            <div class="error" v-if="!$v.rule_usd.required">
                                Kurs tidak boleh kosong
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <button class="btn btn-scondary" @click="hideModal('modalAccepted')" v-show="!isLoading">
                    Cancel
                </button>
                <button class="btn btn-primer" @click="handleSubmit('accepted')">
                    <div v-show="!isLoading">Submit</div>
                    <b-spinner variant="light" small v-show="isLoading" style="width: 20px; height: 20px"></b-spinner>
                </button>
            </template>
        </b-modal>
        <b-modal ref="modalRejected" title="Tolak Deposit Nasabah">
            <div class="d-block text-center">
                Apakah Anda yakin memasukan akun <b>{{ detailDeposit.account_name }}</b> ke dalam daftar Reject?
                <textarea
                    name="input message"
                    cols="60"
                    rows="5"
                    placeholder="Berikan alasan atau kekurangan isian/berkas Nasabah "
                    v-model="$v.messageReject.$model"
                    minlength="30"
                ></textarea>
                <div v-if="$v.messageReject.$error">
                    <div class="error" v-if="!$v.messageReject.required">
                        Alasan tidak boleh kosong
                    </div>
                    <div class="error" v-if="!$v.messageReject.minLength">
                        Alasan minimal 30 karakter
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <button class="btn btn-scondary" @click="hideModal('modalRejected')" v-show="!isLoading">
                    Cancel
                </button>
                <button class="btn btn-primer" @click="handleSubmit('rejected')">
                    <div v-show="!isLoading">Submit</div>
                    <b-spinner variant="light" small v-show="isLoading" style="width: 20px; height: 20px"></b-spinner>
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";
export default {
    data() {
        return {
            dataNsb: [],
            number: 1,
            currentPage: 1,
            perPage: 10,
            loadingData: false,
            platform: "",
            dataPlatform: [],
            detailDeposit: "",
            showDetail: false,
            url: "https://api-kyc-abi-dev.abicommodity.co.id/v2/get/file",
            messageReject: "",
            isLoading: false,
            statusNasabah: "request",
            rule_usd: "",
            resultUsd: "",
            imgResult: "",
        };
    },
    validations: {
        messageReject: {
            required,
            minLength: minLength(30),
        },
        rule_usd: {
            required,
        },
    },

    mounted() {
        // let setPage = (offset - 1) * this.perPage;
        axios.get("/v2/master_data/platform").then((res) => {
            this.dataPlatform = res.data.data;
            this.$store.dispatch("getImageAccess", this.dataAtachment.photo).then((res) => {
                this.dataImags.photo = res;
                this.imgagePreview = res;
            });
        });
        this.getData(this.currentPage, this.platform, this.statusNasabah);
    },

    watch: {
        rule_usd() {
            this.rule_usd = this.currencyFormat(this.rule_usd);
        },
    },

    methods: {
        checngeResult(event) {
            let input = this.formatNumber(event.target.value);
            this.resultUsd = this.detailDeposit.amount / input;
            this.resultUsd = (Math.round(this.resultUsd * 100) / 100).toFixed(2);
        },
        currencyFormat(value) {
            return (value + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        formatNumber(value) {
            return value.replace(/[^\d]/g, "");
        },

        handleSubmit(status) {
            let title;
            if (status == "rejected") {
                this.$v.messageReject.$touch();
                if (this.$v.messageReject.$error) {
                    return;
                }
                title = "<h5>Deposti berhasil ditolak</h5>";
            } else {
                this.$v.rule_usd.$touch();
                if (this.$v.rule_usd.$error) {
                    return;
                }

                title = "<h5>Deposti berhasil diterima</h5>";
            }
            this.isLoading = true;

            axios
                .put("/v2/admin-broker/deposit-confirmation/" + this.detailDeposit._id, {
                    status: status,
                    description: this.messageReject,
                    rate_usd: this.rule_usd,
                })
                .then((res) => {
                    this.isLoading = false;
                    if (res.data.data.status_code == "00") {
                        let id_activity = res.data.data.activity_id;
                        this.$notify({
                            group: "foo",
                            title: title,
                            type: "success",
                            duration: 2000,
                        });
                        this.$store.dispatch("getLocation").then((resGeo) => {
                            let info;
                            if (resGeo.cityData[0]) {
                                info = resGeo;
                            } else {
                                let data = resGeo;
                                data.newLatLong = resGeo.cityLatLong.split(",");
                                info = data;
                            }
                            axios.put("/v2/admin-broker/operator-activity/" + id_activity, info);
                        });
                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    }
                });
        },
        openDetail(data, modal) {
            this.detailDeposit = data;
            this.$store.dispatch("getImageAccess", this.detailDeposit.image).then((res) => {
                this.imgResult = res;
            });

            if (modal == "new") {
                this.$refs["modalAccepted"].show();
            } else if (modal == "old") {
                this.$refs["modalRejected"].show();
            } else if (modal == "detail") {
                this.showDetail = true;
            }
        },
        hideModal(idModal) {
            this.$refs[idModal].hide();
        },
        filterPlatform() {
            this.getData(this.currentPage, this.platform, this.statusNasabah);
        },
        changeStatus(status) {
            this.statusNasabah = status;
            this.getData(this.currentPage, this.platform, status);
        },
        getData(value, platform, status) {
            this.loadingData = true;
            let setPage = (value - 1) * this.perPage;
            let role = localStorage.getItem("role");
            let urlAdmin;
            if (role == "0") {
                urlAdmin = "/v2/superadmin/deposit?offset=" + setPage + "&limit=10&platform_code=" + platform;
            } else {
                urlAdmin = "/v2/admin-broker/deposit-confirmation?status=" + status + "&limit=10&offset=" + setPage + "&platform_code=" + platform;
            }
            axios.get(urlAdmin).then((res) => {
                this.loadingData = false;
                this.dataNsb = res.data.data.deposit_confirmation;
            });
        },
    },
    computed: {
        checkRole() {
            let role = localStorage.getItem("role");
            if (role) {
                return role;
            } else {
                return null;
            }
        },
        paginate() {
            if (!this.dataNsb || this.dataNsb.length != this.dataNsb.length) {
                return;
            }
            var index = this.currentPage * this.perPage - this.perPage;
            return this.dataNsb.slice(index, index + this.perPage);
        },
    },
};
</script>

<style scoped>
.lds-ring {
    display: inline-block;
    /* position: absolute; */
    width: 30px;
    height: 30px;
    /* top: 4px; */
    /* left: 39%; */
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 6px;
    border: 6px solid #1f354a;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1f354a transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

table {
    color: #707070 !important;
}

.nasabah {
    font-size: 14px;
    padding: 0 20px;
}

.title {
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 60px;
}

.image {
    width: 17rem;
    transition: transform 0.5s ease;
}

.image:hover {
    transform: scale(1.5);
}

.wrap-detail {
    position: fixed;
    top: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0px 7px 17px 3px rgb(0 0 0 / 15%);
    padding: 1rem;
    width: 25rem;
    height: 100vh;
    transition: 0.5s ease-out;
    margin-right: -26rem;
}

.activeDetail {
    margin-right: 0;
}

.header-title {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 1.5rem;
    font-weight: bold;
}
.close {
    float: unset;
}

.label {
    font-weight: bold;
    width: 8rem;
}
</style>
